import { ConcreteEncodable } from "./ConcreteEncodable";

import { VisibilityProfileImplEncoder } from "../../encoder/VisibilityProfileImplEncoder";

import * as CubiqTS from "../../index";
import { VisibilityProfile } from "../VisibilityProfile";

export class VisibilityProfileImpl extends ConcreteEncodable implements VisibilityProfile {
  public static enType: string = "com.bcdfx.model.VisibilityProfileImpl";

  /*FID=1*/
  public user: CubiqTS.User | null = null;
  /*FID=2*/
  public visibleClientCds: Array<string> | null = null;
  /*FID=3*/
  public isTraderPrevisibility: boolean;
  /*FID=4*/
  public userVisibilityProfile: CubiqTS.UserVisibilityProfile | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = VisibilityProfileImplEncoder.Instance;
    this.setEncodableType(VisibilityProfileImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "VisibilityProfileImpl[" +
      "user=" +
      this.user +
      "visibleClientCds=" +
      this.visibleClientCds +
      "isTraderPrevisibility=" +
      this.isTraderPrevisibility +
      "userVisibilityProfile=" +
      this.userVisibilityProfile +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
